module.exports = __webpack_public_path__ + "media/images/img_ttl-basic-6f87bc6b56b4278a162a5db615b70b1c.png";